import { CheckCircle2, HelpCircle, Target, Zap } from "lucide-react";
import { CampaignBuilder } from "../components/CampaignBuilder.tsx";

const cardStyle = "bg-white/5 border border-white/10 rounded-xl";

export const PromotePageContent = () => (
  <div className="min-h-screen bg-gradient-to-b from-[#1a1a1a] to-black text-white">
    <div className="container mx-auto px-4 py-10 max-w-5xl space-y-8">
      <header className="animate-fade-up space-y-2">
        <span className="px-3.5 py-1 rounded-full bg-purple-500/10 text-purple-400 inline-block text-xs font-medium border border-purple-500/20">
          Targeted WhatsApp Distribution
        </span>
        <h1 className="text-3xl md:text-5xl font-extrabold text-white tracking-tight leading-tight">
          Promote your event
        </h1>
        <p className="text-gray-400 text-sm sm:text-base max-w-2xl leading-relaxed">
          Push your event directly into the WhatsApp chats of matching
          subscribers in your city. Target by genre, area, age, and gender.
        </p>
      </header>

      {/* Feature highlights */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div className={`${cardStyle} p-5 space-y-2`}>
          <div className="flex items-center gap-2 text-purple-400 font-semibold text-sm">
            <Target size={18} />
            Taste & City Matched
          </div>
          <p className="text-gray-400 text-xs leading-relaxed">
            Only delivered to users who explicitly follow your category or
            musical genre in your city.
          </p>
        </div>
        <div className={`${cardStyle} p-5 space-y-2`}>
          <div className="flex items-center gap-2 text-purple-400 font-semibold text-sm">
            <Zap size={18} />
            Direct WhatsApp Delivery
          </div>
          <p className="text-gray-400 text-xs leading-relaxed">
            Delivered as a personal recommendation straight into WhatsApp chats,
            driving highest open and ticket conversion rates.
          </p>
        </div>
        <div className={`${cardStyle} p-5 space-y-2`}>
          <div className="flex items-center gap-2 text-purple-400 font-semibold text-sm">
            <CheckCircle2 size={18} />
            Fair & Transparent Pricing
          </div>
          <p className="text-gray-400 text-xs leading-relaxed">
            $1 per unique user reached. No minimum commitments, no recurring
            lock-in.
          </p>
        </div>
      </div>

      {/* Campaign Builder */}
      <CampaignBuilder />

      {/* FAQ / How it works */}
      <div className={`${cardStyle} p-6 sm:p-8 space-y-4`}>
        <div className="flex items-center gap-2 text-white font-semibold text-base border-b border-white/10 pb-3">
          <HelpCircle size={18} className="text-purple-400" />
          Frequently Asked Questions
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 text-sm text-gray-300">
          <div className="space-y-1.5">
            <h4 className="font-medium text-white">How does delivery work?</h4>
            <p className="text-xs text-gray-400 leading-relaxed">
              Agent FOMO delivers a sponsored event recommendation note with
              your event name, date, venue, poster, and ticket link directly to
              the selected user count.
            </p>
          </div>
          <div className="space-y-1.5">
            <h4 className="font-medium text-white">
              Can users receive the same push twice?
            </h4>
            <p className="text-xs text-gray-400 leading-relaxed">
              No. Our distribution engine automatically deduplicates recipients
              so no user ever receives the same event recommendation more than
              once.
            </p>
          </div>
          <div className="space-y-1.5">
            <h4 className="font-medium text-white">How do I buy credits?</h4>
            <p className="text-xs text-gray-400 leading-relaxed">
              When creating campaigns, you can top up your balance using secure
              Stripe checkout. Each credit ($1) equals 1 delivered subscriber
              push.
            </p>
          </div>
          <div className="space-y-1.5">
            <h4 className="font-medium text-white">Need custom campaigns?</h4>
            <p className="text-xs text-gray-400 leading-relaxed">
              For recurring event series, large festival takeovers, or
              customized integrations, reach out to us via our support bot on
              WhatsApp.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
);
